

































import {
  Vue,
  Component
} from "@/shared/vuepack";
import {
  AppBrowserTarget,
  isMobileApp,
  openUrl
} from "@/shared/mobileHelper";
import { useCustodianSettingsStore } from "@/shared/store/custodianSettings";
import * as RouteNames from "@/employee/route-names";
import { LeafHouseDisclosureDocumentKey } from "@/shared/types";
import { useSigningDocumentStore } from "@/admin/store/signingDocument";

@Component({
  computed: {
    LeafHouseDisclosureDocumentKey () {
      return LeafHouseDisclosureDocumentKey;
    }
  }
})
export default class InvesmentPerformanceDisclosureCopy extends Vue {

  custodianSettingsStore = useCustodianSettingsStore();
  signingDocumentStore = useSigningDocumentStore();

  RouteNames = RouteNames;

  mounted (): void {
    this.signingDocumentStore.getLeafhouseAccountSignatureDocuments({force: true});
  }

  open (url): void {
    openUrl(url, AppBrowserTarget.system);
  }

  getDocumentUrl (documentKey): string {
    const url = window.location.protocol + "//" + window.location.host + "/#/" + "document-view" + "?documentKey=" + documentKey;
    return url;
  }

  get isMobile (): boolean {
    return isMobileApp();
  }
}
